// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__C8wmX","ScrollX":"Scroll_ScrollX__1FAxQ","ScrollY":"Scroll_ScrollY__s5uDg"};